import React from 'react';

const AboutUsText = () => {
  return (
    <div id='aboutUsText' className="bg-AboutUsBg md:px-20 px-8 md:py-20 py-6 ">
      <div className="flex flex-col justify-center items-center">
        <h2 className="md:text-2xl text-xl font-bold text-gray-800  mb-2">
          About Us
        </h2>
        <p className="text-gray-600 text-center text-xs md:text-lg mb-2">
          At Tender Wise, we simplify the tender process by providing essential
          tools and resources to help you navigate and succeed in bidding. Our
          focus is on delivering up-to-date information and continuous
          improvements, ensuring you’re always equipped to win environmental
          projects with confidence.
        </p>
      </div>
    </div>
  );
};

export default AboutUsText;